import styled, { css } from 'styled-components';
import { mq, getTextType, px2rem, getSpace, getTransition } from '../../../stylesheets/tools';

const disabledColor = 'gray';

const StyledCheckbox = styled.div`
  .checkbox__wrapper {
    position: relative;
    cursor: pointer;
    display: flex;
    width: 100%;
    height: 100%;
  }

  .checkbox__custom-checkbox {
    position: relative;
    width: 35px;
    height: 35px;
    border: 2px solid black;
    border-radius: 8px;
    margin-top: 5px;

    svg {
      position: absolute;
      display: none;
      width: 40px;
      top: -9px;
      left: 0;
    }
  }

  input {
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);

    &:checked ~ .checkbox__custom-checkbox svg {
      display: block;
    }

    &:focus ~ .checkbox__custom-checkbox {
      border-color: blue;
    }
  }

  .checkbox__label {
    position: relative;
    margin-left: ${getSpace('s')};
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: 0%;
  }

  .checkbox__labelText {
    margin-top: ${getSpace('10px')};
    ${getTextType('copyFocused', 'international')};
    display: inline-block;
  }

  .checkbox__copy {
    ${getTextType('copy', 'international')};
    display: block;
    margin-top: ${getSpace('10px')};
  }

  .checkbox__required {
    position: absolute;
    left: -10px;
    font-family: 'Arial';
    font-size: ${px2rem('20px')};

    ${mq('m')} {
      left: -15px;
      font-size: ${px2rem('30px')};
    }
  }

  .checkbox__warn {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: red;
    visibility: hidden;
    opacity: 0;
    padding: 10px 5px;
    ${getTransition('inputError')}
  }

  ${props =>
    props.error &&
    css`
      .checkbox__custom-checkbox {
        border-color: red;
      }

      .input__warn {
        visibility: visible;
        opacity: 1;
      }
    `}

  ${props =>
    props.disabled &&
    css`
      .checkbox__custom-checkbox {
        border-color: ${disabledColor};
      }

      .checkbox__label {
        color: ${disabledColor};
      }
    `}
`;

export default StyledCheckbox;
